import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { style } from './CompletableTextGroup';
import { SimpleTextViewModel } from '../../../../../ViewModel';

interface NumberedTextEntryProps {
    number: number;
    id?: string;
    text: SimpleTextViewModel;
    style?: style;
}

export const CompletableText: React.FC<NumberedTextEntryProps> = ({ text, style }) => {
    const [checked, setChecked] = React.useState<boolean | undefined>(text.TypedData.isComplete);

    // const [text, setText] = React.useState(simpleText.text);

    const checkedName = checked && style === 'line-through' ? ' line-through' : '';

    return (
        <div className="completable-text-entry">
            {
                <Checkbox
                    checked={checked ?? false}
                    className='gl-completableText-checkbox'
                    onChange={
                        (e) => {
                            text.TypedData.isComplete = e.checked ?? false;
                            setChecked(e.checked);
                        }}
                />
            }
            <p className={'gl-completableText-text gl-content-lowered-typography' + checkedName}>{text.TypedData.text}</p>


        </div>
    );
};